export const checklistsPageTabs = {
  checklistTypes: "checklist-types",
  taskTemplates: "task-templates",
} as const;

export const checklistsPageTabValues = [checklistsPageTabs.checklistTypes, checklistsPageTabs.taskTemplates] as const;
